import React from 'react';
import { Card } from "react-bootstrap";
import face_gyorgy_karolyi from "../../assets/img/face_gyorgy_karolyi.png";
import ShowMoreText from "react-show-more-text";
import proj_decaying_chaos from "../../assets/img/proj_decaying_chaos.png";

const Gyorgy_Karolyi_decaying_chaos = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_decaying_chaos} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_gyorgy_karolyi}
              /* this will be the text on the banner */
              alt="The transient charm of decaying chaos"
            />{" "}
            <p className="text7">György Károlyi</p>
            <br />
            <p className="text8">
              Professor{" "}
            </p>
            <p className="text8">Institute of Nuclear Techniques, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Chaos in mathematics and physics is the visibly complicated, unpredictable behaviour 
            or simple systems due to the sensitive dependence on the initial conditions. After 
            Edward Lorenz, this phenomenon is called the butterfly effect. By today, the general 
            properties of chaotic systems have been thoroughly investigated. However, the case of 
            transient chaotic behaviour in systems either with explicit time-dependence or with 
            persistent decay are less studied. The aim of this project is to look for the common 
            properties of purely decaying and of time-dependent dynamical systems in simple 
            mechanical models like the double pendulum.

            <br />
            <br />

            Related literature:{" "}

            <ul>
                <li>
                A.E. Motter, M. Gruiz, Gy. Károlyi, T. Tél: Doubly transient chaos: Generic form of chaos in autonomous dissipative systems. Physical Review Letters 111 (2013) 194101.
                </li>
                <li>
                D. Jánosi, T. Tél: Chaos in Hamiltonian systems subjected to parameter drift. Chaos 29 (2019) 121105.
                </li>
                <li>
                D. Jánosi, T. Tél: Chaos in conservative discrete-time systems subjected to parameter drift. Chaos 31 (2021) 033142.
                </li>
                <li>
                Gy. Károlyi, T. Tél: New features of doubly transient chaos: complexity of decay. Journal of Physics: Complexity 2 (2021) 035001.
                </li>
                <li>
                D. Jánosi, Gy. Károlyi, T. Tél: Climate change in mechanical systems: the snapshot view ofparallel dynamical evolutions. Nonlinear dynamics 106 (2021) 2781-2805.
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gyorgy_Karolyi_decaying_chaos;